import { Field } from "typegraph";

export default class Playlist {
	@Field()
	public bookmarked: boolean;
}



// WEBPACK FOOTER //
// ./src/panels/kb/entities/Playlist.ts